import axios from 'axios';

/**
 * Fetch date range limits for statistic data
 * Returns minimum and maximum dates that can be selected
 *
 * @returns {Promise<{minDate: Date|null, maxDate: Date|null}>}
 */
export const fetchDateRangeLimits = async () => {
  try {
    const response = await axios.get('/api/user/export/statistic-data/date-range');

    const minDate = response.data.min_date ? new Date(response.data.min_date) : null;
    const maxDate = response.data.max_date ? new Date(response.data.max_date) : null;

    return {
      minDate,
      maxDate
    };
  } catch (err) {
    console.error('Error fetching date range limits:', err);
    return {
      minDate: null,
      maxDate: null
    };
  }
};
